import React, {
  DragEventHandler,
  RefObject,
  memo,
} from 'react';
import clsx from 'clsx';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import List from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/MainContent/HPI/List';
import TextArea from 'core/components/TextArea';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import {
  VisitNoteSOAPSectionNames,
} from 'core/constants';
import {
  fieldChangedCSS,
  visitNoteEditorActions,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/MainContent/constants';

type Props = {
  editable: boolean;
  sectionRef?: RefObject<HTMLDivElement>;
  onDragOver?: DragEventHandler<HTMLDivElement>;
};

function HPIData({ editable, sectionRef, onDragOver }: Props) {
  const { control } = useFormContext();
  return (
    <>
      <h2 className="font-semibold nw-subjective-section" ref={sectionRef}>Subjective</h2>
      <List />
      <Controller
        name="additionalHPI"
        control={control}
        render={({ field, fieldState: { isDirty } }) => (
          <Wrapper
            id="AdditionalHPITemplate"
            className={clsx({
              '!mt-0': !editable && field.value?.length === 0,
            })}
          >
            <TextArea
              {...field}
              trackingLabel="Additional HPI"
              id={VisitNoteSOAPSectionNames.AdditionalHPITemplate}
              disabled={!editable}
              classes={{ root: clsx({ [fieldChangedCSS]: isDirty && editable }) }}
              actions={[...visitNoteEditorActions, 'hpi-ai']}
              onDragOver={onDragOver}
            />
          </Wrapper>
        )}
      />
    </>
  );
}

export default memo(HPIData);
